module.exports = __webpack_public_path__ + "img/404.7cb2fb02.png";